// src/NotificationContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import { Toast } from "react-bootstrap";
import ReactDOM from "react-dom";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  // Função para adicionar uma notificação
  const addNotification = useCallback((notification) => {
    // Gera um id único
    const id = new Date().getTime() + Math.random();
    const delay = notification.delay || 5000;
    setNotifications((prev) => [...prev, { id, ...notification, delay }]);
    // Remove automaticamente após o delay
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, delay);
  }, []);

  // Função para remover manualmente uma notificação
  const removeNotification = useCallback((id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification, removeNotification }}>
      {children}
      {ReactDOM.createPortal(
        <div style={{ position: "fixed", bottom: "1rem", right: "1rem", zIndex: 9999 }}>
          {notifications.map((n) => (
            <Toast
              key={n.id}
              onClose={() => removeNotification(n.id)}
              autohide
              delay={n.delay}
              className={`bg-${n.type === "error" ? "danger" : n.type === "success" ? "success" : n.type === "warning" ? "warning" : "info"} text-white shadow-lg mb-2`}
              style={{ minWidth: "250px" }}
            >
              <Toast.Body>{n.message}</Toast.Body>
            </Toast>
          ))}
        </div>,
        document.getElementById("toast-root")
      )}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
